import validation from "./validation";

export default {
  validation: validation,
};
